<div [class]="classes" (click)="onClick()">
  <ng-content></ng-content>
</div>
